import script from "./VATReturns.vue?vue&type=script&setup=true&lang=ts"
export * from "./VATReturns.vue?vue&type=script&setup=true&lang=ts"

import "./VATReturns.vue?vue&type=style&index=0&id=2c6a6882&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c6a6882"]])

export default __exports__